// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZfcX","left":"styles_left__3_GSv"};